import { render, staticRenderFns } from "./workyearAndLevel.vue?vue&type=template&id=b403c2a6&scoped=true"
import script from "./workyearAndLevel.vue?vue&type=script&lang=js"
export * from "./workyearAndLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b403c2a6",
  null
  
)

export default component.exports